export const getArrayOfNumbers = (lastNumber: number): number[] => {
	return Array.from(Array(lastNumber), (_, i) => i + 1);
};

export const turnNumberToRange = (num: number, min: number, max: number) => {
	return Math.floor(Math.random() * (max - min) + min);
};